import { message } from 'skin/event'
import { status } from 'skin/event/status'
import dataUrl from '../../../../../../../config_task'

const click = (obj, ms, story, data, d, action) => {
// сохранение по ссылке <a> без предпросмотра
	const href = dataUrl.url + `/dump/dump.zip`
	fetch(href)
		.then((res) => res.blob())
		.then((blob) => {
			const link = document.createElement('a')
			link.href = URL.createObjectURL(blob)
			link.download = 'dump'
			link.click()
		})
	return status.action
}

export default click
